import { HttpErrorResponse, HttpHandler, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {      
      const { code, message } = error.error || {};
      const status = error.status;
      
      switch (status) {
        case 400:
          return throwError(() => error);
          
        case 401:
          router.navigate(['/login']);
          return EMPTY;
          
        case 403:
          return throwError(() => error);
          
        case 404:
          return throwError(() => error);
          
        case 422:
          return throwError(() => error);
          
        case 500:
          return throwError(() => error);
          
        case 502:
        case 503:
        case 504:
          return throwError(() => error);
          
        default:
          return throwError(() => error);
      }
    })
  );
};
